import React from 'react';
import { Tooltip, TooltipWithoutContainer } from '@instinet-analytics/core-lib';
import classNames from 'classnames';

export default function DetailsPanelValue(props: {
    label: string;
    value: string | undefined;
    tooltip?: string;
    valueTooltip?: string;
    className?: string;
}) {
    const {
        className,
        label,
        value,
        tooltip,
        valueTooltip: valueTooltipProps,
    } = props;

    const valueTooltip = valueTooltipProps ?? (value ?? '').toString();

    const cssClasses = classNames('DetailsPanelValue field', className);

    return (
        <div className={cssClasses}>
            <TooltipWithoutContainer
                className="DetailsPanelValue_label"
                text={tooltip}
                tooltipVisible={false}
            >
                <div className="label">{label}:</div>
            </TooltipWithoutContainer>
            <Tooltip
                className="value DetailsPanelValue_value"
                text={valueTooltip}
            >
                {value}
            </Tooltip>
        </div>
    );
}
